<template>
  <div>
    <fieldset>
      <legend class="text-blue">
        Upload Photos
      </legend>
      <div class="row">
        <div class="col-md-12 tw-h-48">
          <VueFileAgent
            ref="vueFileAgent"
            :theme="'default'"
            :multiple="true"
            :deletable="true"
            :meta="true"
            :linkable="true"
            :accept="'image/*'"
            :maxSize="'10MB'"
            :maxFiles="10"
            :helpText="'Choose images or files'"
            :errorText="{
              type: 'Invalid file type.',
              size: 'Files should not exceed 10MB in size'
            }"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            v-model="fileRecords"
          ></VueFileAgent>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import Vue from 'vue'
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
import { mapActions } from 'vuex'
Vue.use(VueFileAgent)
import httpClient from '@/http-client'
import { forEach } from 'lodash'

export default {
  name: 'uploadPhoto',
  props: ['value'],
  data: function () {
    return {
      fileRecords: [],
      uploadUrl:
        process.env.VUE_APP_PROXY + '/api/student-galleries/upload-files',
      uploadHeaders: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-Test-Header': 'vue-file-agent',
        Authorization: 'Bearer ' + this.$store.state.accessToken
      },
      fileRecordsForUpload: [] // maintain an upload queue
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    ...mapActions('staffStudentGallery', ['removeFileUploaded']),
    uploadFiles: function () {
      // Using the default uploader. You may use another uploader instead.
      forEach(this.fileRecordsForUpload, f => {
        let frm = new FormData()
        frm.append('file', f.file)
        httpClient
          .post('/api/student-galleries/upload-files', frm, {
            onUploadProgress: el => {
              if (el.lengthComputable) {
                f.progressing = Math.round((el.loaded * 100) / el.total)
              }
            }
          })
          .then(response => {
            this.model.attach_file_list.push({
              file_path: response.data.file_path,
              original_file_name: response.data.original_file_name,
              mime_type: response.data.mime_type,
              size: response.data.size,
              size_text: response.data.size_text
            })
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      })

      this.fileRecordsForUpload = []
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      )
    },
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        fileRecord => !fileRecord.error
      )
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )
      this.uploadFiles()
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        var k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
        if (fileRecord.file) {
          let item = this.model.attach_file_list.filter(
            f => f.original_file_name == fileRecord.file.name
          )
          if (item.length > 0) {
            this.removeFileUploaded({
              file_path: item[0].file_path
            })
          }
          let file_index = this.model.attach_file_list.indexOf(
            ...this.model.attach_file_list.filter(
              f => f.file_path == item[0].file_path
            )
          )
          this.model.attach_file_list.splice(file_index, 1)
        } else {
          let item = this.model.attach_file_list.filter(
            f => f.size == fileRecord.size
          )
          if (item.length > 0) {
            this.removeFileUploaded({
              file_path: item[0].file_path
            })
          }
          let file_index = this.model.attach_file_list.indexOf(
            ...this.model.attach_file_list.filter(
              f => f.file_path == item[0].file_path
            )
          )
          this.model.attach_file_list.splice(file_index, 1)
        }
      }
    }
  }
}
</script>
